import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ChatRightTextFill } from 'react-bootstrap-icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'react-bootstrap-dialog';

import axios from 'axios';

import { authMiddleWare } from '../utilities/Auth';

import SearchableStateSelect from '../components/SearchableStateSelect';

const { propertyLookupApiUrl } = require('../utilities/Constants');

const N = (v) => {
    if (v == null) return 0;
    if (typeof v === 'number') return isNaN(v) ? 0 : v;
    const s = String(v).replace(/[^0-9.\-]/g, '');
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};
const P = (v) => {
    if (v == null) return 0;
    if (typeof v === 'number') return isNaN(v) ? 0 : v;
    const s = String(v).replace('%', '').trim();
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

class PropertyLookupDialog extends Component {

    state = {
        isOpen: false,
        loading: false,
        elapsedSeconds: 0,
        stateCode: '_',
        parentReference: null,
        profile: null,
        settings: null,
        profileId: null,
        investmentType: null,
        user: null,
        onSuccess: null,
        onError: null
    };

    countUpInterval = null;

    open = ({ parentReference, profile, settings, profileId, investmentType, user, onSuccess, onError }) => {
        this.setState({
            isOpen: true,
            loading: false,
            elapsedSeconds: 0,
            stateCode: '_',
            parentReference,
            profile,
            settings,
            profileId,
            investmentType,
            user,
            onSuccess: onSuccess || null,
            onError: onError || null
        }, () => {
            setTimeout(() => {
                const a = document.getElementById('propertyLookupDialogAddress');
                if (a) a.value = '';
                const c = document.getElementById('propertyLookupDialogCity');
                if (c) c.value = '';
                const z = document.getElementById('propertyLookupDialogZip');
                if (z) z.value = '';
            }, 50);
        });
    };

    close = () => {
        this.stopCountUp();
        this.setState({ isOpen: false, loading: false, elapsedSeconds: 0 });
    };

    handleStateSelect = (code) => {
        this.setState({ stateCode: code });
    };

    startCountUp = () => {
        this.stopCountUp();
        this.countUpInterval = setInterval(() => {
            this.setState({ elapsedSeconds: this.state.elapsedSeconds + 1 });
        }, 1000);
    };

    stopCountUp = () => {
        if (this.countUpInterval != null) {
            clearInterval(this.countUpInterval);
            this.countUpInterval = null;
        }
    };

    handleLookup = () => {
        const street = (document.getElementById('propertyLookupDialogAddress') || {}).value || '';
        const city = (document.getElementById('propertyLookupDialogCity') || {}).value || '';
        const zip = (document.getElementById('propertyLookupDialogZip') || {}).value || '';
        const state = this.state.stateCode;

        if (street.trim() === '' || state === '' || state === '_') {
            alert('Please enter a valid address and state.');
            return;
        }

        if (this.state.profileId == null || this.state.profileId === '') {
            alert('Please select a profile before looking up the property.');
            return;
        }

        this.setState({ loading: true, elapsedSeconds: 0 });
        this.startCountUp();

        const payload = {
            street,
            city,
            state,
            zip,
            profileId: this.state.profileId,
            investmentType: this.state.investmentType
        };

        authMiddleWare(this?.props?.history);
        const authToken = localStorage.getItem('AuthToken');
        const refreshToken = localStorage.getItem('RefreshToken');
        axios.defaults.headers.common = { Authorization: `${authToken}`, RefreshToken: refreshToken };

        axios({
            url: propertyLookupApiUrl,
            method: 'post',
            data: payload,
            timeout: 500000
        })
        .then((response) => {
            if (response.headers['authtoken'] && response.headers['refreshtoken']) {
                localStorage.setItem('AuthToken', `Bearer ${response.headers['authtoken']}`);
                localStorage.setItem('RefreshToken', response.headers['refreshtoken']);
            }

            const data = response.data || {};
            const propertyString = JSON.stringify(data).trim();
            if (propertyString === '' || propertyString === '{}') {
                this.handleFailure('The lookup returned no results.');
                return;
            }

            this.saveProperty(data);
        })
        .catch((err) => {
            const status = err?.response?.status;
            if (status === 401 || status === 403) {
                localStorage.setItem('SessionExpired', 'Y');
                window.location.href = '/login';
                return;
            }
            if (
                (status === 402 && err?.response?.data?.code === 'INSUFFICIENT_CREDITS') ||
                (status === 402 &&
                err?.response?.data?.error?.includes('At least') &&
                err?.response?.data?.error?.includes('credits are required'))
            ) {
                this.stopCountUp();
                this.setState({ loading: false });

                const info = err.response.data || {};

                const purchase = window.confirm(
                    info.error ||
                    (
                        'You do not have enough credits to run this property lookup.\n\n' +
                        `Available credits: ${Number(info.balance || 0).toLocaleString('en-US')}\n` +
                        `Minimum credits required: ${Number(info.requiredCredits || 0).toLocaleString('en-US')}\n\n` +
                        'Would you like to purchase additional credits now?'
                    )
                );

                if (purchase) {
                    window.location.href = info.buyCreditsUrl || '/pricing';
                }

                return;
            }
            this.handleFailure(err?.response?.data?.error || err);
        });
    };

    handleFailure = (err) => {
        console.log('PropertyLookupDialog failure:', err);
        this.stopCountUp();
        const onError = this.state.onError;
        this.setState({ isOpen: false, loading: false, elapsedSeconds: 0 }, () => {
            if (typeof onError === 'function') onError(err);
        });
    };

    // Build a property record from the lookup response and post it to
    // /api/createProperty. Mirrors the fields used by PropertyEditDialog.HandleSave.
    saveProperty = (data) => {
        try {
            const settings = this.state.settings || {};
            const investmentType = this.state.investmentType;
            const propertyType = this.normalizePropertyType(data.propertyType, data.street);

            const price = N(data.price);
            const marketValue = N(data.estimate);
            const downPayment = N(data.downPayment);
            const closingCosts = N(data.closingCosts);
            const monthlyPayment = N(data.monthlyPayment);
            const monthlyRent = N(data.rent);
            const term = this.parseTerm(data.loanTerm);
            const livingArea = N(data.livingArea);
            const pricePerSqft = N(data.pricePerSqft);

            let marketValuePercent = 10;
            let marketValuePercentAboveBelow = 'below';
            if (marketValue > 0 && price > 0) {
                const pct = ((marketValue - price) / marketValue) * 100;
                marketValuePercent = Math.abs(Math.round(pct * 100) / 100);
                marketValuePercentAboveBelow = pct >= 0 ? 'below' : 'above';
            }

            const property = {
                profileId: this.state.profileId,
                nickName: '',
                price,
                marketValue,
                marketValuePercent: `${marketValuePercent}%`,
                marketValuePercentAboveBelow,
                downPayment,
                downPaymentPercent: `${P(data.downPaymentPercent)}%`,
                closingCosts,
                interestRate: P(data.interestRate),
                annualAppreciation: `${P(data.annualAppreciation || settings.annualHomeAppreciationPercent || 0)}%`,
                rentRateOfGrowth: P(data.rentRateOfGrowth),
                expenseRateOfGrowth: P(data.expenseRateOfGrowth),
                vacancyRate: P(data.vacancyRate),
                monthlyPayment,
                monthlyRent,
                monthlyBills: 0,
                monthlyGrossIncome: 0,
                creditScore: this.state.profile?.creditScore || '',
                monthlyExpenses: 0,
                initialExpenses: closingCosts + downPayment,
                projectedSaleProceeds: 0,
                trendingMonthlyRent: monthlyRent,
                pricePerSqft,
                trendingPricePerSqft: N(data.trendingPricePerSqft),
                mls: data.mls || '',
                propertyLink: data.propertyLink || '',
                address: data.street || '',
                city: data.city || '',
                state: data.state || '',
                zipcode: data.zip || '',
                country: 'US',
                investmentType,
                propertyType,
                propertySubType: data.propertySubType || '',
                financingType: 'Loan',
                term,
                loanType: 'Conventional',
                repaymentType: 'P&I',
                projectedYearOfSale: 'Year 10',
                propertyImage: data.propertyImageHighResolution || '',
                propertyNotes: '',
                principalAndInterest: N(data.principalAndInterest),
                propertyTaxes: N(data.propertyTaxes),
                homeownersInsurance: N(data.homeInsurance),
                otherMonthlyPayment: 0,
                hoa: N(data.hoa),
                livingAreaSize: livingArea,
                lotSize: N(data.lotSize),
                afterRepairValue: N(data.afterRepairValue),
                sellingCosts: 0,
                sellingCostsPercent: `${P(settings.sellingCostPercent || 0)}%`,
                holdingCosts: 0,
                rehabCosts: 0,
                rehabType: 'Cosmetic Rehab',
                budget: 0,
                holdingMonths: N(settings.holdingMonths || 0),
                numberBedrooms: data.numberBedRooms || '',
                numberBathrooms: data.numberBathRooms || '',
                yearBuilt: data.yearBuilt || '',
                similarSoldProperties: data.similarSoldProperties || [],

                id: null,
                alertId: null,
                createdBy: localStorage.getItem('SessionUserName'),
                createdDate: new Date().toISOString(),
                releasedDate: new Date().toISOString(),
                greenIndicatorsFound: 0,
                greenIndicatorsRequired: null,
                uniquePropertyIdentifier: data.propertyLink || '',
                queuedFlag: 'N',
                indicators: []
            };

            authMiddleWare(this?.props?.history);
            const authToken = localStorage.getItem('AuthToken');
            const refreshToken = localStorage.getItem('RefreshToken');
            axios.defaults.headers.common = { Authorization: `${authToken}`, RefreshToken: refreshToken };

            axios.post('/api/createProperty', property)
                .then((response) => {
                    if (response.headers['authtoken'] && response.headers['refreshtoken']) {
                        localStorage.setItem('AuthToken', `Bearer ${response.headers['authtoken']}`);
                        localStorage.setItem('RefreshToken', response.headers['refreshtoken']);
                    }
                    this.stopCountUp();
                    const onSuccess = this.state.onSuccess;
                    const parentRef = this.state.parentReference;
                    this.setState({ isOpen: false, loading: false, elapsedSeconds: 0 }, () => {
                        try { if (parentRef && typeof parentRef.loadProperties === 'function') parentRef.loadProperties(); } catch (e) { /* ignore */ }
                        if (typeof onSuccess === 'function') onSuccess(property);
                    });
                })
                .catch((error) => {
                    console.log('createProperty error:', error);
                    if (error?.response?.status === 403) {
                        localStorage.setItem('SessionExpired', 'Y');
                        window.location.href = '/login';
                        return;
                    }
                    this.handleFailure(error);
                });
        } catch (err) {
            console.log('saveProperty error:', err);
            this.handleFailure(err);
        }
    };

    normalizePropertyType = (type, street) => {
        try {
            const t = (type || '').toLowerCase();
            const s = (street || '').toLowerCase();
            if (t.includes('manufactur') || t.includes('mobile')) return 'Mobile Home';
            if (t.includes('apartment') || t.includes('multi family') || t.includes('duplex') || t.includes('triplex') || t.includes('fourplex')) return 'Multi-family';
            if (s.includes(' unit ') || s.includes(' apt ')) return 'Condo';
            if (t.includes('typehome') || t.includes('singlefamily') || t.includes('single family')) return 'Single Family Home';
            if (t.includes('lots') || t.includes('land')) return 'Lot';
        } catch (e) { /* ignore */ }
        return 'Single Family Home';
    };

    parseTerm = (loanTerm) => {
        if (!loanTerm) return 30;
        const n = parseInt(String(loanTerm).replace(/[^0-9]/g, ''));
        return isNaN(n) || n <= 0 ? 30 : n;
    };

    render() {
        const { isOpen, loading, elapsedSeconds, stateCode } = this.state;

        return (
            <React.Fragment>
                <Modal
                    show={isOpen}
                    onHide={this.close}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Property Lookup
                            {loading && (
                                <span style={{ paddingLeft: '26px', fontSize: '18px', color: '#4e73df' }}>
                                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                        {elapsedSeconds < 60
                                            ? elapsedSeconds
                                            : `${Math.floor(elapsedSeconds / 60)}m ${elapsedSeconds % 60}s`}
                                    </span>
                                    {elapsedSeconds < 60 ? ' Seconds...' : ''}
                                </span>
                            )}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '16px' }}>
                        <div style={{ color: '#333333', marginBottom: '12px' }}>
                            <ChatRightTextFill style={{ color: '#4e73df' }}/> &nbsp;
                            <div style={{paddingBottom: '6px'}}>
                            Gorepa researches the property using publicly available records and data sources.
                            </div>
                            The lookup typically takes <b>3–8 minutes</b> because Gorepa gathers far more than basic property details. Along with the property's core information, it retrieves:
                            
                            <div style={{paddingTop: '6px', paddingBottom: '6px', color:'#2B2B2B'}}>
                             Market value • Vacancy rate • Rent growth • Price trends • Comparable sales 
                             </div>

                             and more—saving you hours of research.
                             </div>
                 

                        <div className="form-group">
                            <label className="dialog-form-label" htmlFor="propertyLookupDialogAddress">Address Line</label>
                            <input type="text" className="form-select lookup-input" id="propertyLookupDialogAddress" placeholder="i.e. 123 Main St" defaultValue="" />
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="dialog-form-label" htmlFor="propertyLookupDialogCity">City</label>
                                    <input type="text" className="form-select lookup-input" id="propertyLookupDialogCity" placeholder="i.e. Anytown" defaultValue="" />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="dialog-form-label" htmlFor="propertyLookupDialogStateDropdown">State</label>
                                    <SearchableStateSelect
                                        id="propertyLookupDialogStateDropdown"
                                        value={stateCode}
                                        borderColor="#2563EB"
                                        placeholder="—"
                                        onChange={(code) => this.handleStateSelect(code)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="dialog-form-label" htmlFor="propertyLookupDialogZip">Zip Code</label>
                                    <input type="text" className="form-select lookup-input" id="propertyLookupDialogZip" maxLength="5" placeholder="i.e. 99999" defaultValue="" />
                                </div>
                            </div>
                        </div>

                        {loading && (
                            <div style={{ textAlign: 'center', padding: '16px 0' }}>
                                <CircularProgress size={60} />
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleLookup} disabled={loading}>LookUp</Button>
                        <Button variant="secondary" onClick={this.close} disabled={loading}>Close</Button>

                        <div style={{ color: '#4A4A4A', marginBottom: '12px', paddingTop: '6px', fontSize: '13px' }}>
                                <i>
                                <b>Don't want to wait?</b> Create an Advanced Search from the left navigation. It runs in the background and notifies you when matching properties are found.
                                </i>
                         </div>
                    </Modal.Footer>
                </Modal>
                <Dialog ref={(component) => { this.dialog = component; }} />
            </React.Fragment>
        );
    }
}

export default PropertyLookupDialog;
